import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import classnames from "classnames";
import Link from "next/link";
import PropTypes from "prop-types";
import React from "react";
import NewLabel from "../new-label/NewLabel";
import styles from "./OptionButton.module.scss";

function OptionButton({
  title,
  className,
  contentClassName,
  imgSrc,
  imgAlt,
  imgContainerClassName,
  imgClassName,
  onClick,
  href,
  isNew,
}) {
  return (
    <Link href={href} shallow scroll>
      <SecondaryButton
        className={classnames(styles.button, styles.button2, className, !imgSrc ? styles.buttonOnlyText : "")}
        onClick={onClick}
      >
        {isNew && <NewLabel className={classnames(styles.newLabel, styles.newLabel_desktop)} />}
        <div className={classnames(styles.__content, contentClassName)}>
          <div className={imgContainerClassName}>
            {imgSrc && <img src={imgSrc.src} alt={imgAlt || title} className={imgClassName} />}
          </div>
          <div>
            {isNew && <NewLabel className={classnames(styles.newLabel, styles.newLabel_mobile)} />}
            <span className={styles.__text}>{title}</span>
          </div>
        </div>
        <div className={styles.__chevron}>
          <ChevronRight />
        </div>
      </SecondaryButton>
    </Link>
  );
}

OptionButton.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  imgClassName: PropTypes.string,
  imgContainerClassName: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  contentClassName: PropTypes.string,
  isNew: PropTypes.bool,
};

OptionButton.defaultProps = {
  className: undefined,
  imgSrc: undefined,
  imgAlt: undefined,
  imgClassName: undefined,
  imgContainerClassName: undefined,
  onClick: undefined,
  href: undefined,
  contentClassName: undefined,
  isNew: false,
};

export default OptionButton;
